import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const AuthLayout = () => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary-600"></div>
      </div>
    );
  }
  
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <img 
          src="/images/logo_full.png" 
          alt="Logo RIDE-DF"
          className="mx-auto w-full max-w-4xl"
        />
      </div>
      
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <Outlet />
          <div className="flex justify-center items-center gap-16 mt-8 mb-0">
            <img
              src="/images/logo_sudeco.png"
              alt="Logo Sudeco"
              className="h-8 w-auto object-contain"
            />
            <img
              src="/images/logo_unb.png"
              alt="Logo UnB"
              className="h-8 w-auto object-contain"
            />
          </div>                  
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
